export default function Connect() {
  return (
    <section className="connect-page">
      <span className="section-label">04 — Connect</span>
      <h2>Let's Talk</h2>
      <p className="page-intro">Get in touch or find me elsewhere on the internet.</p>

      <div className="connect-links">
        <a href="mailto:li.bra@northeastern.edu" className="connect-link">
          <span className="connect-link-label">Email</span>
          <span className="connect-link-value">li.bra@northeastern.edu</span>
        </a>
        <a href="https://github.com/bradylii" target="_blank" rel="noopener noreferrer" className="connect-link">
          <span className="connect-link-label">GitHub</span>
          <span className="connect-link-value">bradylii</span>
        </a>
        <a href="https://www.linkedin.com/in/brady-li-78328b23b/" target="_blank" rel="noopener noreferrer" className="connect-link">
          <span className="connect-link-label">LinkedIn</span>
          <span className="connect-link-value">brady-li</span>
        </a>
        <a href="/Brady_Li_CV.pdf" target="_blank" rel="noopener noreferrer" className="connect-link">
          <span className="connect-link-label">CV</span>
          <span className="connect-link-value">Brady_Li_CV</span>
        </a>
      </div>
    </section>
  );
}
